import { graphql } from "gatsby";

import { ModularTemplate } from "./ModularTemplate";

export const pageQuery = graphql`
  query($id: String!) {
    allContentfulGlobalSettings(
      filter: { bannerName: { eq: "Global Site Setting -BannerText" } }
    ) {
      edges {
        node {
          bannerLinkText
          bannerLinkUrl
          topBannerDisplay
          bannerText
        }
      }
    }
    contentfulModularTemplate(id: { eq: $id }) {
      id
      pageTitle
      urlPath
      canonicalUrlPath
      updatedAt
      metaTitle
      metaDescription {
        metaDescription
      }
      structuredData {
        internal {
          type
          content
        }
      }
      noIndex: doNotIndex
      hideHamburger
      includeAggregateRating
      hero {
        ...hero
      }
      shortTitle
      partner
      enableAbTesting
      usHrefLang
      hideHeader
      hideFooter
      hideLogin
      showSmallFooter
      betterV2
      snapScroll
      applyLinks {
      text
      url
    }
      parentPage {
        ... on Node {
          ... on ContentfulModularTemplate {
            shortTitle
            urlPath
            parentPage {
              ... on Node {
                ... on ContentfulModularTemplate {
                  shortTitle
                  urlPath
                  parentPage {
                    ... on Node {
                      ... on ContentfulModularTemplate {
                        shortTitle
                        urlPath
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }

      modules {
        __typename
        ... on Node {
          ...authorByline
        }
        ... on Node {
          ...bigLinksPanel
        }
        ... on Node {
          ...featureWithCtas
        }
        ... on Node {
          ...splashPanel
        }
        ... on Node {
          ...accordionPanel
        }
        ... on Node {
          ...calculatorPanel
        }
        ... on Node {
          ...contentWithSidebarPanel
        }
        ... on Node {
          ...comparisonPanel
        }
        ... on Node {
          ...mortgageComparisonPanel
        }
        ... on Node {
          ...trustpilotPanel
        }
        ... on Node {
          ...pullOutBlocksPanel
        }
        ... on Node {
          ...gridPanel
        }
        ... on Node {
          ...asSeenOnPanel
        }
        ... on Node {
          ...articlePanel
        }
        ... on Node {
          ...linksPanel
        }
        ... on Node {
          ...horizontalCardsPanel
        }
        ... on Node {
            ...verticalCardsPanel
        }
        ... on Node {
            ...lenderPanel
        }
        ... on Node {
            ...specialisedStructuredData
        }
      }
    }
  }

  fragment asSeenOnPanel on ContentfulAsSeenOnPanel {
    title
    logos {
      title
      file {
        url
      }
    }
    logosMobile {
      title
      file {
        url
      }
    }
  }

  fragment gridPanel on ContentfulGridPanel {
    id
    bgColour
    title
    gridColumns {
      title
      url
      headingType
      description
      gridText {
        url
        cardText
      }
    }
  }

  fragment authorByline on ContentfulAuthorByline {
    heading
    name
    title
    image {
      title
      file {
        url
        fileName
      }
      gatsbyImageData(placeholder: BLURRED, width: 60, height: 60)
    }
    url
  }

  fragment bigLinksPanel on ContentfulBigLinkPanel {
    id
    title
    headingType
    bgColour
    title
    content {
      raw
    }
    callToActions {
      isBigLink
      title
      subtitle
      url
      image {
        id
        title
        file {
          url
          fileName
          contentType
        }
      gatsbyImageData(placeholder: BLURRED, width: 80, height: 80)
      }
    }
  }

  fragment featureWithCtas on ContentfulFeaturesWithCtas {
    id
    title
    backgroundColour
    imageWithTitleAndText {
      title
      body {
        id
        body
      }
      hasTitleBelowBody
      image {
        title
        file {
          fileName
          url
          contentType
        }
      gatsbyImageData(placeholder: BLURRED)
      }
    }
    ctas {
      title
      url
      subtitle
    }
  }

  fragment hero on ContentfulHero {
    id
    size
    heading1 {
      raw
    }
    heading2  {
      raw
    }
    disclaimerText  {
      raw
    }
    firstCta {
      title
      url
      subtitle
      description
    }
    secondCta {
      title
      url
      subtitle
      description
    }
    image {
      title
      file {
        fileName
        url
        contentType
      }
      gatsbyImageData(placeholder: BLURRED, width: 600, height: 400)
    }
    imageFullWidth: image {
      title
      file {
        fileName
        url
        contentType
      }
      gatsbyImageData(placeholder: BLURRED, layout: FULL_WIDTH, quality: 90)
    }
    imageMobile {
      title
      file {
        fileName
        url
        contentType
      }
      gatsbyImageData(placeholder: BLURRED, layout: FULL_WIDTH, quality: 90)
    }
    trustpilotIconLink {
      url
    }
    heroVersion
    colourPreset
    callToActions {
      url
      title
      subtitle
      image {
       title
       file {
        fileName
        url
        contentType
       }
       gatsbyImageData(placeholder: BLURRED, width: 48, height: 48)
     }
    }
    optionLinks {
     text
     url
     
    }
    variant
    bullets
    bulletsTitle
    showLogo
  }

  fragment splashPanel on ContentfulSplashPanel {
    id
    title
    headingType
    alignment
    backgroundColour
    mainContent {
      raw
    }
    callToActions {
      url
      title
      subtitle
      description
    }
    disclaimer {
      raw
    }
    image {
      title
      file {
        fileName
        url
        contentType
      }
      gatsbyImageData(placeholder: BLURRED)
    }
    imageBorderRadius
    lookerId
    youTubeVideoId
    hubSpotPortalId
    hubSpotFormId
    saasquatchTenantAlias
    saasquatchWidgetType
    infogramId
    mediaAlignment
    mediaWidth
    variant
    tickCrossList {
      items { 
        text
        type
      }
    }
    preset
  }

  fragment accordionPanel on ContentfulAccordionPanel {
    id
    title
    titleSecondary
    headingType
    backgroundColour
    textAlign
    variant
    firstTabVariant
    secondTabVariant
    accordionTitle
    accordionTitleSecondary
    content {
      raw
    }
    accordion {
      title
      secondaryTitle
      content {
        raw
      }
      image {
        title
        file {
          fileName
          url
          contentType
        }
        gatsbyImageData(placeholder: BLURRED)
      }
    }
    accordionSecondary {
      title
      secondaryTitle
      content {
        raw
      }
      image {
        title
        file {
          fileName
          url
          contentType
        }
        gatsbyImageData(placeholder: BLURRED)
      }
    }
    callToActions {
      title
      subtitle
      url
    }
  }

  fragment calculatorPanel on ContentfulCalculatorPanel {
    id
    title
    betterV2
    multipleTabs
    defaultTab
    description {
      raw
    }
    disclaimer {
      raw
    }
    footerHeading
    footerText
    ctaText
    ctaUrl
    secondCtaText
    secondCtaUrl
    calculatorType
    mortgageRateOverride
    showExampleSavings
    fastestLender {
      raw
    }
    mortgageRateBasedOnLtv {
        defaultValue,
        rates {
            ltv,
            mortgageRate
        }
    }
  }

  fragment contentWithSidebarPanel on ContentfulContentWithSidebarPanel {
    id
    title
    backgroundColour
    content {
      raw
    }
    sections {
      title
      secondaryTitle
      content {
        raw
      }
      image {
        title
        file {
          fileName
          url
          contentType
        }
      }
    }
    callToActions {
      title
      subtitle
      url
    }
  }

  fragment mortgageComparisonPanel on ContentfulMortgageComparisonPanel {
    id
    rateTypeDefault
    repaymentPeriodDefault
    propertyValueDefault
    mortgageAmountDefault
    initialPeriodDefault
    interestOnlyDefault
    buyToLetDefault
    sortOptionDefault
    showFilterPanel
    showHeader
    trustHeader
    headerTitle
    headerText
    mortgagePurpose
    lenderFilter
  }

  fragment comparisonPanel on ContentfulComparisonPanel {
    id
    title
    headingType
    isBetterV2
    variant
    content {
      raw
    }
    backgroundColour
    link {
      text
      url
    }
    callToAction {
      title
      url
      subtitle
    }
    comparisonCards {
      title
      headingType
      items {
        title
        content {
          raw
        }
        image {
          title
          file {
            fileName
            url
            contentType
          }
          gatsbyImageData(placeholder: BLURRED)
        }
      }
    }
  }

  fragment trustpilotPanel on ContentfulTrustpilotPanel {
    id
    header
    headerAlignment
    noPaddingBottom
    variant
    customerReviews {
      internal {
        content
      }
    }

  }

  fragment pullOutBlocksPanel on ContentfulPullOutBlocksPanel {
    id
    variant
    title
    headingType
    backgroundColour
    content {
      raw
    }
    blocks {
      title
      subtitle
      headingType
      alignment
      backgroundColour
      description
      image {
        title
        file {
          fileName
          url
          contentType
        }
      gatsbyImageData(placeholder: BLURRED)
      }
      content {
        raw
      }
      link {
        text
        url
      }
    }
    callToActions {
      title
      url
      subtitle
    }
    version
  }

  fragment articlePanel on ContentfulArticlePanel {
    id
    title
    showCtaCard
    image {
      title
      file {
        url
      }
      gatsbyImageData(placeholder: BLURRED)
    }
    content {
      raw
    }
  }

  fragment linksPanel on ContentfulLinksPanel {
    id
    title
    subtitle
    linksList {
      text
      links {
        url
        text
        target
      }
    }
  }

  fragment horizontalCardsPanel on ContentfulHorizontalCardsPanel {
    id
    variant
    isBetterV2
    subtitle
    titleRichText: title {
      raw
    }
    cards {
      title 
      body {
        body
      }
      headingType
    }
  }

  fragment verticalCardsPanel on ContentfulVerticalCardsPanel {
      id
      titleRichText {
        raw
      }
      backgroundColour
      betterV2
      callToAction {
          url
          title
          subtitle
      }
      cards {
          title
          body {
            body
          }
          headingType
          betterV2
          badgeText
      }
  }
  
  fragment lenderPanel on ContentfulLenderPanel {
      title
      subtitleRichText: subtitle {
        raw
      }
      images {
        id
        file {
          url
        }
        title
        description
        gatsbyImageData(placeholder: BLURRED, width: 117, height: 48)
      }
  }

  fragment specialisedStructuredData on ContentfulSpecialisedStructuredData {
    type
  }
`;
export default ModularTemplate;
